import http from "@/http-common";

/* eslint-disable */
class FAQInfoDataService {

    getFAQ(data: any): Promise<any> {
        return http.api.post('/getFAQ/', data);
    }

    getAllFAQ(data: any): Promise<any>{
        return http.api.post('/getAllFAQ/', data);
    }

    getRowFAQ(data: any): Promise<any> {
        return http.api.post('/getRowFAQ/', data);
    }

    getFAQFile(data: any): Promise<any> {
        return http.api.post('/getFAQFile/', data);
    }

    addFAQ(data: any): Promise<any>{
        return http.api.post("/addFAQ/", data);
    }

    updateFAQ(data: any): Promise<any>{
        return http.api.post("/updateFAQ/", data);
    }

    deleteFAQ(data: any): Promise<any>{
        return http.api.post("/deleteFAQ/", data);
    }

    accessToFile(data: any): Promise<any>{
        return http.api.post('/accessToFile/', data);
    }
}

export default new FAQInfoDataService();